import { GetCoursesByClub } from '@/app/shared/services/courseService/courseService';

const courseStore = {
  state: {
    selectedCourse: null,
    availableCourses: [],
  },

  mutations: {
    setAvailableCourses(state, value) {
      value.sort((a, b) => a.name.localeCompare(b.name));
      state.availableCourses = value;

      // let results = value.filter(c => c.name === state.selectedCourse.name)
      // if (state.selectedCourse === null || results.length === 0) {
      // console.log(state.selectedCourse)
      state.selectedCourse = value[0];
      // }
    },

    setSelectedCourse(state, value) {
      state.selectedCourse = value;
    },
  },

  actions: {
    setSelectedCourse(context, value) {
      return new Promise((resolve) => {
        context.commit('setSelectedCourse', value);
        resolve();
      });
    },

    async getAvailableCourses({ state, commit }, selectedClub) {
      await GetCoursesByClub(selectedClub.id).then(
        (data) => {
          commit('setAvailableCourses', data);
        },
        () => {

        },
      );
    },

  },

};

export { courseStore };
